module.exports = __webpack_public_path__ + "static/media/icon-inbox.8c292cbc.svg";